<template>
  <div class="admin-container py-6 px-4">
    <div class="admin-wrap">
    <div class="d-flex flex-wrap align-center justify-space-between mb-6 mb-md-8 gap-3">
      <div class="d-flex align-center">
        <v-btn icon color="white" to="/akademie" class="mr-2 mr-md-4">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
        <h2 class="text-h5 text-md-h4 font-weight-bold white--text">Akademie Administration</h2>
      </div>
      <v-chip color="red" text-color="white">Admin-Bereich</v-chip>
    </div>

    <v-tabs v-model="adminTab" background-color="transparent" color="#D4AF37" dark class="mb-6" show-arrows>
      <v-tab>Module &amp; Lektionen</v-tab>
      <v-tab>Schulungen</v-tab>
      <v-tab>Reports</v-tab>
    </v-tabs>

    <v-tabs-items v-model="adminTab" class="transparent-bg" dark>
      <v-tab-item>
        <v-card dark class="pa-3 pa-md-6 rounded-xl" style="background: rgba(30, 30, 30, 0.8)">
          <ModuleManager />
        </v-card>
      </v-tab-item>
      <v-tab-item>
        <v-card dark class="pa-3 pa-md-6 rounded-xl" style="background: rgba(30, 30, 30, 0.8)">
          <TerminManager />
        </v-card>
      </v-tab-item>
      <v-tab-item>
        <LicenseOverview />
      </v-tab-item>
    </v-tabs-items>
    </div>
  </div>
</template>

<script>
import ModuleManager from "./ModuleManager.vue"
import TerminManager from "./TerminManager.vue"
import LicenseOverview from "../reports/LicenseOverview.vue"

export default {
  name: "AkademieAdmin",
  components: {
    ModuleManager,
    TerminManager,
    LicenseOverview,
  },
  data() {
    return {
      adminTab: 0,
    }
  },
}
</script>

<style scoped>
.admin-container {
  min-height: 100vh;
  background-color: #121212;
}
.admin-wrap {
  max-width: 1400px;
  margin: 0 auto;
}
.transparent-bg {
  background-color: transparent !important;
}
.gap-3 { gap: 12px; }
</style>
